import { convertBitcoinNum } from "../../utils/util";

export type DashboardItemType = {
  chainName: string;
  totalVal: number;
  SATs: number;
  addr: string;
  contractUrl: string;
};

const DashboardItem = ({
  chainName,
  totalVal,
  SATs,
  addr,
  contractUrl,
}: DashboardItemType): JSX.Element => {
  type USDBalance = {
    usdName: string;
    balance: number;
  };

  const USDs = [{ usdName: "SATs", balance: SATs } as USDBalance];
  return (
    <div
      className="w-11/12 min-w-fit min-h-fit  rounded-2xl border-none shadow-[0px_0px_2px_2px_rgba(153,153,153,0.5)] flex flex-col items-center p-2 m-1
        lg:w-[380px] lg:min-w-[380px] lg:h-[200px] lg:gap-5  bg-gray-900 bg-opacity-70"
    >
      <p className="text-base text-[#fff] lg:text-xl">{chainName}</p>
      <p className="text-lg text-[#fff] lg:text-3xl">{totalVal} SATs <span className="text-sm">{"(≈ " + convertBitcoinNum(totalVal) + "₿)"}</span></p>
      <a
        href={contractUrl}
        target={"_blank"}
        className="text-xs font-thin text-[#fff] mt-3 lg:text-sm lg:font-normal lg:mt-4"
      >
        {addr}
      </a>
    </div>
  );
};

export default DashboardItem;
